import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ productCard }: RootState) => productCard;

export const selectProductCard = createSelector(
    selectRoot,
    ({ productCard }) => productCard,
);
